import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";

// import { ReactComponent as AlertSVG } from "assets/img/Alert.svg";

import breakpoints from "_constants/breakpoints";
import AddPaymentMethodModal from "components/BillingInformation/AddPaymentMethodModal";
import { customerActions, ordersActions } from "_store/actions";
import { useDispatch, useSelector } from "react-redux";
import { error as errorNotif } from "react-notification-system-redux";
import { SpinnerWrapper } from "widget/Spinner";

const TextBox = styled.div`
  font-size: 18px;
  color: white;
  min-height: 40px;
  width: 100%;
  max-width: 1364px;
  padding: 12px;
  text-align: center;
  background-color: #f05050;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;

  & > div {
    max-width: 860px;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    font-size: 16px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: ${breakpoints.mobileM}) {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
`;

const Button = styled.button`
  min-width: 160px;
  padding: 14px 24px;
  color: #f05050;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.5;
  background-color: #fafaff;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #f0f0ff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    background-color: #f0f0f5;
    color: #a0a0a7;
    cursor: not-allowed;
    opacity: 0.9;
    box-shadow: none;
    transform: none !important;

    &:hover,
    &:active {
      background-color: #f0f0f5;
      box-shadow: none;
      transform: none;
    }
  }

  @media (max-width: ${breakpoints.mobileM}) {
    width: 100%;
    max-width: 280px;
  }
`;

function ChargeUSPTOFeeAlert({ orderId, product }) {
  const dispatch = useDispatch();

  const { paymentMethods, paymentMethodsLoading } = useSelector(({ customer }) => customer);
  const { feeRechargeLoading } = useSelector(({ orders }) => orders);
  const primaryCard = paymentMethods?.find(({ primary }) => primary);

  const [isModalOpen, setModalOpen] = useState(false);

  const productId = product?.id;

  const handleReAttempt = () => {
    if (orderId && productId) {
      dispatch(ordersActions.feeRecharge({ orderId, productId }));
    } else {
      errorNotif({ title: "Error", message: "Unable to charge USPTO fee" });
    }
  };

  const handleAddPaymentMethod = (cardDetails) => {
    setModalOpen(false);
    dispatch(customerActions.postPaymentMethod(cardDetails, handleReAttempt));
  };

  useEffect(() => {
    dispatch(customerActions.getPaymentMethods());
  }, [dispatch]);

  return (
    <>
      <TextBox>
        <div>
          <h3>Card Declined</h3>
          <p>
            Important! Upon attempting to pull the USPTO filing fee, we received a declined message for your payment
            method. Please either re-attempt your old payment method or replace it, to re-attempt with a new one.
          </p>
          <ButtonGroup>
            <Button disabled={paymentMethodsLoading || feeRechargeLoading} onClick={() => handleReAttempt()}>
              Re-attempt
            </Button>
            <Button disabled={paymentMethodsLoading || feeRechargeLoading} onClick={() => setModalOpen(true)}>
              Replace
            </Button>
          </ButtonGroup>
        </div>
      </TextBox>
      <AddPaymentMethodModal
        show={isModalOpen}
        onCancel={() => setModalOpen(false)}
        onConfirm={handleAddPaymentMethod}
        primaryId={primaryCard?.paySourceId}
      />
      {feeRechargeLoading && <SpinnerWrapper />}
    </>
  );
}

ChargeUSPTOFeeAlert.propTypes = {
  orderId: PropTypes.string,
  product: PropTypes.object,
};

export default ChargeUSPTOFeeAlert;
